import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import helpers, { getAdditionalData, statusUpdater } from "wvus-sponsorship-engine";
import { getChildren } from "wvus-sponsorship-engine";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSlidersH } from "@fortawesome/free-solid-svg-icons";
import Messaging from "../Common/Messaging";
import SearchCurated from "./SearchCurated";
import SearchStandard from "./SearchStandard";
import { addBodyClass, removeBodyClass, noFuncProps } from "../../utils/helpers";
import { getZeroChildrenMessage } from "../../utils/app-settings";
import { gtmTrackEventData } from "../../utils/gtm-event-triggers";
import MobileSearchClose from "./MobileSearchClose";
import { InlineToggle } from 'slide-ui';
import { toScrollElement } from "../../utils/helpers";
const MIN_DAYS_COUNT = 2000;
let countryData; // this will be used as a cache for the country data

class Countries extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  associateCountriesToRegions(region, isRegion, allLocations) {
    const countriesList = allLocations
      .filter((x) => {
        if (x.region == region) {
          return x;
        }
        return false;
      })
      .map((item, index) => {
        return (
          <option key={index} value={item.code}>
            {item.isRegion ? `All of ${item.country}` : item.country}
          </option>
        );
      });

    return countriesList;
  }

  render() {
    if (this.props.isRegion) {
      return (
        <optgroup label={this.props.country}>
          {this.associateCountriesToRegions(
            this.props.region,
            this.props.isRegion,
            this.props.allLocations
          )}
        </optgroup>
      );
    } else {
      return false;
    }
  }
}

class ChildSearch extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      countryCodes: [],
      gender: "",
      minimumAge: "",
      maximumAge: "",
      minimumBirthMonth: "",
      maximumBirthMonth: "",
      minimumBirthDayOfMonth: "",
      maximumBirthDayOfMonth: "",
      displaySearchForm: true,
      countryName: "Worldwide",
      orphan: 0,
      childCount: null,
      previousSearch: false,
      disabled: false,
      minimumDaysAwaitingSponsorshipCount: "",
      reservationReferenceIdentifier: null,
      projectIdentifiers: null,
      formSearched: false,
    };
    this.state = this.initialState;
    this.renderLocations = this.renderLocations.bind(this);
    this.generateNumbers = this.generateNumbers.bind(this);
    this.selectValues = this.selectValues.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.renderSearchForm = this.renderSearchForm.bind(this);
    this.handleSearchReset = this.handleSearchReset.bind(this);
    this.renderMessage = this.renderMessage.bind(this);
    this.resetSearchParams = this.resetSearchParams.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.hydrateAdditionalData = this.hydrateAdditionalData.bind(this);

    if (!countryData) {
      this.hydrateAdditionalData();
    } else {
      this.setState((state, props) => {
        return {
          ...state,
          ...countryData
        };
      });
    }
  }
  componentDidMount() {
    this.mobileSearch(false);

    //disable the reset all button if no filters are being used
    if (
      this.props.searchMethod === "random" &&
      this.props.status === "COMPLETE"
    ) {
      this.props.enableClearAll(true);
    }

  }

  /**
   * This function will hydrate the additional data for the search form
   * This data will come from the sponsorship engine and will be cached using the countryData variable
  **/
  hydrateAdditionalData(callback = () => {}) {
    const additionalData = getAdditionalData();

    additionalData.then(resp => {
      const respData = {
        countrySelect: resp.locations,
        highRiskArea: resp.highRiskArea,
        hungerCrisis: resp.hungerCrisis
      };

      this.setState((state, props) => {
        return {
          ...state,
          ...respData
        };
      });
      countryData = respData;

      callback();
    });
  }

  renderLocations(data) {
    let countries = [];

    for (let key in data) {
      if (data[key][0] != "not available") {
        countries.push({
          code: data[key][0],
          country: data[key][1],
          isRegion: data[key][3],
          region: data[key][2],
        });
      }
    }

    return countries;
  }
  generateNumbers(min, max) {
    let numberArray = [];
    let start = min;

    for (let i = min; i <= max; i++) {
      numberArray.push(i);
    }

    return numberArray;
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.status !== this.props.status &&
      this.props.searchMethod === "search" &&
      this.props.status === "COMPLETE"
    ) {
      this.updateSearchUI();
    }

    if (prevProps.ADPSearch !== this.props.ADPSearch) {
      this.updateSearchUI();
    }
  }

  updateSearchUI() {
    const countrySelect = this.state?.countrySelect ? this.state.countrySelect : countryData?.countrySelect ? countryData.countrySelect : [];
    const locations = this.renderLocations(countrySelect);
    let countryCode = null;
    if (
      this.props.submissions.children.request.searchCriteriaList[0].countryCodes
    ) {
      this.props.submissions.children.request.searchCriteriaList[0].countryCodes
        .length > 1
        ? (countryCode = "Various")
        : (countryCode =
            this.props.submissions.children.request.searchCriteriaList[0]
              .countryCodes[0]);
    }

    if (this.props.ADPSearch) {
      countryCode = this.props.projectDescription;
    }

    return this.setState(
      {
        ...this.state,
        ...this.props.submissions.children.request.searchCriteriaList[0],
        countryName: this.findCountryNameByCode(
          locations,
          countryCode,
          false,
          this.props.ADPSearch
        ),
        previousSearch: true,
        disabled: false,
        //resetFiltersDisabled: false,
      },
      () => {
        this.props.renderShowMore();
      }
    );
  }
  handleSearch(value, searchTerm, props) {
    this.setState({ formSearched: true });
    this.props.animateGrid(true);
    this.props.updatelastSearchKeyStatus(false);
    this.props.toggleErrorMessage(false);
    this.props.statusUpdater("EDITING");
    this.setState({ disabled: true });
    this.props.resetShowMore();
    typeof this.props.reservePool !== "undefined"
      ? this.setState({
          reservationReferenceIdentifier: this.props.reservePool,
        })
      : this.setState({ reservationReferenceIdentifier: undefined });
    typeof this.props.projectIdentifiers !== "undefined"
      ? this.setState({ projectIdentifiers: this.props.projectIdentifiers })
      : this.setState({ projectIdentifiers: undefined });
    
    //handle min/max values for same term
    if (Array.isArray(searchTerm)) {
      const arrayLength = searchTerm.length;
      let i = 1;
      for (let key of searchTerm) {
        this.setState({ [key]: value }, () => {
          //only call getChildren after state is updated with all values from array.
          if (i === arrayLength) {
            this.props.getChildren(this.props.take, this.state, () => {
              this.props.resetGridCalc();
            });
          }

          const fireAnalyticsOnce = (i < 2);
          fireAnalyticsOnce && gtmTrackEventData("spon_app_child_interaction", {
            "event_action": "search_by_detail",
            "search_params": this.state,
            "search_props": noFuncProps(this.props),
          });

          // Increment
          i++;
        });
      }
    } else {
      this.setState({ [searchTerm]: value }, () => {
        gtmTrackEventData("spon_app_child_interaction", {
          "event_action": "search_by_detail",
          "search_state": this.state,
          "search_props": noFuncProps(this.props),
        });

        this.props.getChildren(this.props.take, this.state, () => {
          this.props.resetGridCalc();
        });
      });
    }

    this.props.renderShowMore();
  }

  handleSearchReset(changeFocus = false, elementId = "Location") {
    this.props.animateGrid(true);
    this.props.resetShowMore();
    if (document.getElementById("sponsorship-search")) {
      document.getElementById("sponsorship-search").reset();
    }
    this.setState(this.initialState);
    this.props.getChildren(
      this.props.take,
      {
        reservationReferenceIdentifier: this.props.reservePool,
        projectIdentifiers: this.props.projectIdentifiers,
      },
      () => {
        this.props.renderShowMore();
        this.props.enableClearAll(false);
      }
    );
    this.props.resetGridCalc();
    if (changeFocus) {
      //this may be needed to remove focus of the clear button on mobile search.  Leaving commented for now.  JS 8/6/18
      // document.getElementById(elementId).focus();
    }
  }
  resetSearchParams() {
    this.setState(this.initialState);
  }

  selectValues(numberList) {
    return numberList.map((item, index) => {
      return (
        <option key={index} value={item}>
          {item}
        </option>
      );
    });
  }

  mobileSearch(bool = false) {
    if (this.props.device === "tablet" || this.props.device === "mobile") {
      this.setState({ displaySearchForm: bool });
    }
  }

  detectFailover() {
    if (this.props.failover === true) {
      this.setState((prevState) => ({
        displaySearchForm: !prevState.displaySearchForm,
      }));
    }
  }

  toggleSearch(e) {
    e.preventDefault();
    this.setState(
      (prevState) => ({
        displaySearchForm: !prevState.displaySearchForm,
      }),
      () => {
        if (this.props.device != "desktop") {
          if (!this.state.displaySearchForm) {
            removeBodyClass("search-takeover");
            toScrollElement();
          } else {
            addBodyClass("search-takeover");
          }
        }
      }
    );
  }
  findCountryNameByCode(data, countryCode, curated = false, adpSearch = false) {
    if (adpSearch) {
      const text = this.props.projectDescription;
      if (text.length > 7) {
        return text.substring(0, 6) + "...";
      }
      return text;
    }

    if (countryCode === "Various") {
      return "Various";
    }

    if (countryCode && !curated) {
      const obj = data.find((x) => x.code === countryCode);
      return obj.country;
    } else {
      return this.state.countryName;
    }
  }
  renderActiveTabContent(tab, searchQuery, countriesList) {
    switch (tab) {
      case "detail":
        return (
          <SearchStandard
            uiHasInteracted={this.state}
            initialState={this.initialState}
            searchQuery={searchQuery}
            countriesList={countriesList}
            handleSearch={this.handleSearch}
            handleSearchReset={this.handleSearchReset}
            generateNumbers={this.generateNumbers}
            selectValues={this.selectValues}
            renderMessage={this.renderMessage}
            enableClearAll={this.props.enableClearAll}
            resetFiltersDisabled={this.props.resetFiltersDisabled}
            toggleSearch={this.toggleSearch}
            {...this.props}
          />
        );
      case "curated":
        return (
          <SearchCurated
            searchQuery={searchQuery}
            handleSearch={this.handleSearch}
            resetSearchParams={this.resetSearchParams}
            renderMessage={this.renderMessage}
            toggleSearch={this.toggleSearch}
            hungerCrisis={this.state.hungerCrisis}
            highRiskArea={this.state.highRiskArea}
            {...this.props}
          />
        );
      default:
        return (
          <SearchStandard
            uiHasInteracted={this.state}
            initialState={this.initialState}
            searchQuery={searchQuery}
            countriesList={countriesList}
            handleSearch={this.handleSearch}
            handleSearchReset={this.handleSearchReset}
            generateNumbers={this.generateNumbers}
            selectValues={this.selectValues}
            renderMessage={this.renderMessage}
            enableClearAll={this.props.enableClearAll}
            resetFiltersDisabled={this.props.resetFiltersDisabled}
            toggleSearch={this.toggleSearch}
            {...this.props}
          />
        );
    }
  }
  renderSearchToggle() {
    return (
      <div className="children-search__toggle">
        <InlineToggle
          selectedValue={this.props.tabSelected}
          sendOnChange={(event) => {
            const searchMethod = event.target.value;
            gtmTrackEventData("spon_app_child_interaction", {
              "event_action": "child_finder_tab_click",
              "search_method": searchMethod
            });

            if (searchMethod === "detail") {
              // DETAIL - SEARCH BY DETAILS
              this.mobileSearch(true);
              this.handleSearchReset();
              this.props.searchMethodSelector(searchMethod);
              this.props.setSelectedValue("longest-waiting");
            } else {
              // CURATED - SEARCH BY NEED
              this.mobileSearch(true);
              this.resetSearchParams();
              this.handleSearch(
                MIN_DAYS_COUNT,
                "minimumDaysAwaitingSponsorshipCount"
              );
              this.props.searchMethodSelector(searchMethod);
            }
          }}
          options={[
            { "Search By Details": "detail" },
            { "Search By Need": "curated" },
          ]}
        />
      </div>
    );
  }
  renderSearchForm() {
    if (
      this.state.displaySearchForm === true ||
      (!this.props.failover && this.props.device === "desktop")
    ) {
      const countrySelect = this.state?.countrySelect ? this.state.countrySelect : countryData?.countrySelect ? countryData.countrySelect : [];
      const locations = this.renderLocations(countrySelect);
      const locationList = locations;
      const countriesList = locations.map((item, index) => {
        return (
          <Countries
            key={index}
            id={index}
            {...item}
            allLocations={locationList}
          />
        );
      });
      let searchQuery = {};

      if (
        this.props.searchMethod === "search" &&
        this.props.status === "COMPLETE"
      ) {
        searchQuery = {
          ...this.props.submissions.children.request.searchCriteriaList[0],
        };
      }

      const searchDisplay = this.props.appConfigs.settings.searchDisplay;
      return (
        <section className="container_children-search">
          <MobileSearchClose toggleSearch={this.toggleSearch} {...this.props} />
          {this.renderSearchToggle()}
          {this.renderActiveTabContent(
            this.props.tabSelected,
            searchQuery,
            countriesList
          )}
        </section>
      );
    } else {
      return false;
    }
  }
  getSearchSelections() {
    const searchSelectionValues = [
      document.querySelector("#sponsorship-search #Location"),
      document.querySelector("#sponsorship-search #Gender"),
      document.querySelector("#sponsorship-search #Age"),
      document.querySelector("#sponsorship-search #Month"),
      document.querySelector("#sponsorship-search #Day"),
    ].map(item => item && item.value || "");

    return searchSelectionValues;
  }

  renderMessage(props) {
    let text = "All fields are optional";
    const hideSearch = this?.props?.appConfigs?.settings?.searchDisplay === "hidden";
    const searchSelections = this.getSearchSelections();
    const hasSelection = searchSelections.some(value => !!value);
    const displayCount = !hideSearch && hasSelection;

    if (
      (props.searchMethod === "search" && props.status === "COMPLETE") ||
      this.state.previousSearch === true
    ) {
      const x = this.props.submissions.children.responseData.totalCount;
      const xSuffix = "children match your search";
      switch (true) {
        case (x > 500 && displayCount):
          text = <span>500+ {xSuffix}</span>;
          break;
        case x === 0:
          if (props.device !== "desktop") {
            text = <span>0 matching children</span>;
          }
          if (props.ADPSearch && !this.state.formSearched) {
            text = (
              <span>
                Oops, there are no children available in{" "}
                {this.props.projectDescription}. Please check back later or call{" "}
                <a href="tel:18885116548">1.888.511.6548</a> to sponsor a child
                today.
              </span>
            );
          } else {
            text = getZeroChildrenMessage();
          }
          break;
        case displayCount:
          text = `${x} ${xSuffix}`;
          break;
        default:
          text = "";
      }

      if (text) {
        return <Messaging messageText={text} classList={["orange"]} />;
      }
    }

    if (props.device !== "desktop") {
      // text = "All fields are optional";
      return <Messaging messageText={text} classList={[""]} />;
    }
  }
  render() {
    let mobileGenderText = "";
    if (this.state.gender === "M") {
      mobileGenderText = "Boy";
    } else if (this.state.gender === "F") {
      mobileGenderText = "Girl";
    }

    if (!this.props.failover) {
      return (
        <section className={`container search-ui`}>
          <a href="" onClick={(e) => this.toggleSearch(e)}>
            <div className="search-term-results wvus-grid">
              <div className="search-icon results__item">
                <FontAwesomeIcon icon={faSearch} />
              </div>
              <div className="results__item">
                <span className="search-heading">Location</span>
                <span className="search-term">
                  {this.state.countryName || "Worldwide"}
                </span>
              </div>
              <div className="results__item">
                <span className="search-heading">Gender</span>
                <span className="search-term">{mobileGenderText || "Any"}</span>
              </div>
              <div className="results__item">
                <span className="search-heading">Age</span>
                <span className="search-term">
                  {this.state.maximumAge || "Infant-14"}
                </span>
              </div>
              <div className="results__item results__item--toggle">
                <span className="search-heading">More</span>
                <span className="search-term">
                  <FontAwesomeIcon icon={faSlidersH} />
                </span>
              </div>
            </div>
          </a>
          {this.renderSearchForm()}
        </section>
      );
    } else {
      return false;
    }
  }
}

function mapStateToProps(state) {
  return {
    ...state,
    formRequest: state.children,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getChildren: getChildren,
      statusUpdater: statusUpdater,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(ChildSearch);
